import * as React from 'react';
import { useEventCallback } from '@cian/react-utils';
import { useDispatch, useSelector } from 'react-redux';
import { sendFeedbackAction } from '../../store/feedback/actions';
import { NotFoundForFilters } from '../../components/NotFoundForFilters';
import { NotFoundForLocation } from '../../components/NotFoundForLocation';
import { selectHint } from '../../selectors/villages';
import { IFeedbackRequest } from '../../types/feedback';
import { TTypedThunkDispatch } from '../../types/store';
import { FeedbackModal } from '../../components/feedback/modal';
import { selectIsMobile } from '../../selectors/mobile';
import { NotFoundForFiltersMobile } from '../../components/mobile/NotFoundForFiltersMobile';
import { showMobileFilters } from '../../store/mobile/actions';
import { NotFoundForLocationMobile } from '../../components/mobile/NotFoundForLocationMobile';

export const NotFoundContainer = () => {
  const [isModalVisible, setModalVisible] = React.useState(false);
  const hint = useSelector(selectHint);
  const isMobile = useSelector(selectIsMobile);
  const dispatch = useDispatch<TTypedThunkDispatch>();

  const sendFeedback = useEventCallback((params: IFeedbackRequest) => {
    return dispatch(sendFeedbackAction(params));
  });

  const toggleModal = useEventCallback(() => {
    setModalVisible(!isModalVisible);
  });

  const showFilters = useEventCallback(() => {
    return dispatch(showMobileFilters(true));
  });

  const NotFoundForLocationComponent = isMobile ? NotFoundForLocationMobile : NotFoundForLocation;

  return (
    <>
      {!hint || hint.regionHasVillages ? (
        isMobile ? (
          <NotFoundForFiltersMobile showFilters={showFilters} />
        ) : (
          <NotFoundForFilters />
        )
      ) : (
        <NotFoundForLocationComponent url={hint.seo?.url} openModal={toggleModal} />
      )}
      {isModalVisible && (
        <FeedbackModal isMobile={isMobile} onModalClose={toggleModal} sendFeedbackAction={sendFeedback} />
      )}
    </>
  );
};
